import { render, staticRenderFns } from "./DarkForgotPassword.vue?vue&type=template&id=500c0f7e&scoped=true"
import script from "./DarkForgotPassword.vue?vue&type=script&lang=js"
export * from "./DarkForgotPassword.vue?vue&type=script&lang=js"
import style0 from "./DarkForgotPassword.vue?vue&type=style&index=0&id=500c0f7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "500c0f7e",
  null
  
)

export default component.exports